import React, { useEffect, useState } from 'react'
import { Section, Grid, Card, Img, Heading, Hint, Overlay, OverlayImg, CloseButton } from './OpinioesClientes.elements'
import { Container } from '../../globalStyles'

const OpinioesClientes = ({ features, titulo }) => {
  const [aberta, setAberta] = useState(null)

  // Fecha a imagem ampliada com Esc e trava o scroll da página enquanto está aberta
  useEffect(() => {
    if (aberta === null) return
    const onKey = (e) => e.key === 'Escape' && setAberta(null)
    document.addEventListener('keydown', onKey)
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = ''
    }
  }, [aberta])

  return (
    <Section>
      <Container>
        {titulo && <Heading>{titulo}</Heading>}

        <Grid>
          {features.map((item, i) => (
            <Card
              key={i}
              type="button"
              onClick={() => setAberta(i)}
              aria-label={`Ampliar depoimento: ${item.title}`}
            >
              <Img src={item.img} alt={`Depoimento de cliente: ${item.title}`} loading="lazy" />
            </Card>
          ))}
        </Grid>

        <Hint>Toque em um depoimento para ampliar</Hint>
      </Container>

      {aberta !== null && (
        <Overlay onClick={() => setAberta(null)} role="dialog" aria-modal="true">
          <CloseButton type="button" aria-label="Fechar" onClick={() => setAberta(null)}>
            ×
          </CloseButton>
          <OverlayImg
            src={features[aberta].img}
            alt={`Depoimento de cliente: ${features[aberta].title}`}
            onClick={(e) => e.stopPropagation()}
          />
        </Overlay>
      )}
    </Section>
  )
}

export default OpinioesClientes
